function isValidISIN(isin: string): boolean {
  const isinRegex = /^[A-Z]{2}[-]{0,1}[A-Z0-9]{9}[-]{0,1}[0-9]{1}$/;
 
  return isinRegex.test(isin);
}

export default isValidISIN;